import React, { memo } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import ButtonMaterial from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import palette from "./styles/palette";

const useStyles = makeStyles({
  root: ({
    bgColor,
    bgColorDisabled,
    color,
    colorDisabled,
    border,
    opacityDisabled,
    disableBorder,
  }) => ({
    backgroundColor: bgColor,
    color,
    border,
    "&:hover": {
      backgroundColor: bgColor,
    },
    "&:disabled": {
      backgroundColor: bgColorDisabled || bgColor,
      color: colorDisabled || color,
      opacity: opacityDisabled || 1,
      border: disableBorder || border,
    },
  }),
  minWidthZero: {
    minWidth: 0,
  },
});

const Button = ({
  bgColor,
  bgColorDisabled,
  color,
  border,
  disableBorder,
  colorDisabled,
  className,
  minWidthZero,
  opacityDisabled,
  ...props
}) => {
  const styles = useStyles({
    bgColor,
    bgColorDisabled,
    color,
    colorDisabled,
    border,
    disableBorder,
    opacityDisabled,
  });

  return (
    <ButtonMaterial
      variant="contained"
      color="primary"
      className={clsx(className, styles.root, {
        [styles.minWidthZero]: minWidthZero,
      })}
      {...props}
    />
  );
};

Button.muiName = ButtonMaterial.muiName;

Button.defaultProps = {
  bgColor: "inherit",
  color: palette.typography.white.solid,
  border: "none",
  disableBorder: "none",
  minWidthZero: false,
};

Button.propTypes = {
  nativeColor: PropTypes.string,
  minWidthZero: PropTypes.bool,
  ...ButtonMaterial.propTypes,
};

export default memo(Button);
